import { render, staticRenderFns } from "./copper_board_type.vue?vue&type=template&id=37dca14d"
import script from "./copper_board_type.vue?vue&type=script&lang=js"
export * from "./copper_board_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports